import React, { Component } from "react";
import { ErrorCode, INTERMEDIATE_OUTPUT_FILES } from "../../../../const";
import { v4 as uuidv4 } from "uuid";
import Alert from "sweetalert-react";
import * as Http from "../../../../http";
import * as Business from "../../../../utils/business";
import Loading from "../../../../components/Loading";
import {
  ProgressBar,
  MenuItem,
  DropdownButton,
  FormGroup,
  FormControl,
  InputGroup,
  Button,
  Table,
  ControlLabel,
} from "react-bootstrap";
import UpdateNameAndReportDateModalModal from "../../../../components/UpdateNameAndReportDate";

const dicSingleConsol = {
  single: "SINGLE",
  consol: "CONSOL",
};

const dicFilterModule = {
  cr_cor: "CR COR",
  mr_ccr: "MR CCR",
  or: "OR",
  irrbb_lr: "IRRBB LR",
};

const dicFilterPeriods = {
  all: "All",
  none: "None",
  t0: "T0",
  t1: "T1",
  t2: "T2",
  t3: "T3",
};
const dicFilterScenario = {
  all: "All",
  none: "None",
};

const dicScenario = {
  lowest_car: "CAR thấp nhất",
  lowest_lev: "LEV thấp nhất",
};

class FileInfo extends Component {
  constructor(props) {
    super(props);
    const fileInfo = props.location.state || {};
    const lstInputFiles = fileInfo.input_files
      ? JSON.parse(fileInfo.input_files)
      : [];
    this.state = {
      singleConsol: "single",
      scenario: "lowest_car",
      filterIntermediateOutput: {
        scenario: "all",
        period: "all",
        module: "cr_cor",
      },
      isShowUpdateNameAndReportDateModal: false,
      isSelectAllInput: false,
      isSelectAllOutput: false,
      isSelectAlIntermediateOutput: false,
      fileInfo: fileInfo,
      lstInput: lstInputFiles.map((e) => ({
        input: e.name,
        upload_by: fileInfo.upload_by,
        upload_time: Business.convertToFullDate(fileInfo.upload_time),
      })),
      lstOutput: [],
      dicIntermediateOutputByFilter: {},
      lstIntermediateOutput: [],
      failedDownloadsList: [],
      reportDate: Business.convertToDate(fileInfo.report_date),
      reportName: fileInfo.file_name || "",
      status: Business.convertFileStatus(fileInfo.status),
      reason: fileInfo.reason,
      loading: false,
      hasResult: false,
      showRejectAlert: false,
      showFileDownloadError: false,
      isDisableRejectButton:
        fileInfo.status !== Business.ENUMS.FILE_STATUS.WAITING_FOR_APPROVAL,
      isDisableApprovalButton:
        fileInfo.status !== Business.ENUMS.FILE_STATUS.WAITING_FOR_APPROVAL,
      isDisableReasonInput:
        fileInfo.status !== Business.ENUMS.FILE_STATUS.WAITING_FOR_APPROVAL,
      isDisableCalculateButton:
        fileInfo.status !== Business.ENUMS.FILE_STATUS.APPROVED &&
        fileInfo.status !== Business.ENUMS.FILE_STATUS.CALCULATION_STOPPED,
    };
  }

  listReportWillDelete = null;

  componentDidMount() {
    clearGetBatchDownloadInterval();
    Http.getListScenarios(this.state.reportDate, this.state.reportName).then(
      (data) => {
        if (data && data.Success && data.Data) {
          for (let i = 0; i < data.Data.length; i++) {
            dicScenario[data.Data[i].toLowerCase()] =
              data.Data[i].toUpperCase();
            dicFilterScenario[data.Data[i].toLowerCase()] =
              data.Data[i].toUpperCase();
          }
        }
        if (
          this.state.fileInfo.status === Business.ENUMS.FILE_STATUS.CALCULATED
        ) {
          this.getReportList();
        } else {
          this.setState({ loading: false });
        }
      },
    );
  }

  mappingDicIntermediateOutputByFilter = (lstIntermediateOutput) => {
    const dicIntermediateOutputByFilter = {};
    if (lstIntermediateOutput && lstIntermediateOutput.length > 0) {
      for (let i = 0; i < lstIntermediateOutput.length; i++) {
        const item = lstIntermediateOutput[i];
        const report_name = `${item.report_name}`.toLowerCase();

        const isContain = (array, reportName) => {
          let result = false;
          array.forEach((s) => {
            if (`${reportName}`.toLowerCase().includes(`${s}`.toLowerCase())) {
              result = true;
              return;
            }
          });
          return result;
        };

        let module = "";
        if (isContain(INTERMEDIATE_OUTPUT_FILES.CR_COR, report_name)) {
          module = "cr_cor";
        } else if (isContain(INTERMEDIATE_OUTPUT_FILES.MR_CCR, report_name)) {
          module = "mr_ccr";
        } else if (isContain(INTERMEDIATE_OUTPUT_FILES.OR, report_name)) {
          module = "or";
        } else {
          module = "irrbb_lr";
        }

        if (!dicIntermediateOutputByFilter[`${module}_all_all`])
          dicIntermediateOutputByFilter[`${module}_all_all`] = {};
        if (!dicIntermediateOutputByFilter[`${module}_all_none`])
          dicIntermediateOutputByFilter[`${module}_all_none`] = {};
        if (!dicIntermediateOutputByFilter[`${module}_all_t0`])
          dicIntermediateOutputByFilter[`${module}_all_t0`] = {};
        if (!dicIntermediateOutputByFilter[`${module}_all_t1`])
          dicIntermediateOutputByFilter[`${module}_all_t1`] = {};
        if (!dicIntermediateOutputByFilter[`${module}_all_t2`])
          dicIntermediateOutputByFilter[`${module}_all_t2`] = {};
        if (!dicIntermediateOutputByFilter[`${module}_all_t3`])
          dicIntermediateOutputByFilter[`${module}_all_t3`] = {};
        let isHasScenario = false;
        Object.keys(dicFilterScenario).forEach((s) => {
          if (s === "all") return;
          if (!dicIntermediateOutputByFilter[`${module}_${s}_all`])
            dicIntermediateOutputByFilter[`${module}_${s}_all`] = {};
          if (!dicIntermediateOutputByFilter[`${module}_${s}_none`])
            dicIntermediateOutputByFilter[`${module}_${s}_none`] = {};
          if (!dicIntermediateOutputByFilter[`${module}_${s}_t0`])
            dicIntermediateOutputByFilter[`${module}_${s}_t0`] = {};
          if (!dicIntermediateOutputByFilter[`${module}_${s}_t1`])
            dicIntermediateOutputByFilter[`${module}_${s}_t1`] = {};
          if (!dicIntermediateOutputByFilter[`${module}_${s}_t2`])
            dicIntermediateOutputByFilter[`${module}_${s}_t2`] = {};
          if (!dicIntermediateOutputByFilter[`${module}_${s}_t3`])
            dicIntermediateOutputByFilter[`${module}_${s}_t3`] = {};
          if (report_name.includes(`_${s}_`)) {
            dicIntermediateOutputByFilter[`${module}_all_all`][report_name] =
              item;
            dicIntermediateOutputByFilter[`${module}_${s}_all`][report_name] =
              item;
            if (report_name.includes(`_t0_`)) {
              dicIntermediateOutputByFilter[`${module}_${s}_t0`][report_name] =
                item;
              dicIntermediateOutputByFilter[`${module}_all_t0`][report_name] =
                item;
            } else if (report_name.includes(`_t1_`)) {
              dicIntermediateOutputByFilter[`${module}_${s}_t1`][report_name] =
                item;
              dicIntermediateOutputByFilter[`${module}_all_t1`][report_name] =
                item;
            } else if (report_name.includes(`_t2_`)) {
              dicIntermediateOutputByFilter[`${module}_${s}_t2`][report_name] =
                item;
              dicIntermediateOutputByFilter[`${module}_all_t2`][report_name] =
                item;
            } else if (report_name.includes(`_t3_`)) {
              dicIntermediateOutputByFilter[`${module}_${s}_t3`][report_name] =
                item;
              dicIntermediateOutputByFilter[`${module}_all_t3`][report_name] =
                item;
            } else {
              dicIntermediateOutputByFilter[`${module}_${s}_none`][
                report_name
              ] = item;
              dicIntermediateOutputByFilter[`${module}_all_none`][report_name] =
                item;
            }
            isHasScenario = true;
          }
        });
        if (!isHasScenario) {
          dicIntermediateOutputByFilter[`${module}_all_all`][report_name] =
            item;
          dicIntermediateOutputByFilter[`${module}_none_all`][report_name] =
            item;
          if (report_name.includes(`_t0_`)) {
            dicIntermediateOutputByFilter[`${module}_all_t0`][report_name] =
              item;
          } else if (report_name.includes(`_t1_`)) {
            dicIntermediateOutputByFilter[`${module}_all_t1`][report_name] =
              item;
          } else if (report_name.includes(`_t2_`)) {
            dicIntermediateOutputByFilter[`${module}_all_t2`][report_name] =
              item;
          } else if (report_name.includes(`_t3_`)) {
            dicIntermediateOutputByFilter[`${module}_all_t3`][report_name] =
              item;
          } else {
            dicIntermediateOutputByFilter[`${module}_none_none`][report_name] =
              item;
            dicIntermediateOutputByFilter[`${module}_all_none`][report_name] =
              item;
          }
        }
      }
    }
    return dicIntermediateOutputByFilter;
  };

  getReportList = () => {
    Http.getListReport(
      Business.COMPONENT.NSFR,
      this.state.fileInfo.file_name,
    ).then((data) => {
      const lstOutput = [];
      const lstIntermediateOutput = [];
      if (data && data.Success && data.Data) {
        data.Data.forEach((item) => {
          const isLiquidityFinalReport = /LIQ2/i.test(item.report_name || "");
          if (
            !Business.isOutputFile(item.report_name) &&
            !isLiquidityFinalReport
          )
            return;
          item.created = Business.convertToFullDate(item.created);
          if (Business.isIntermediateOutputFiles(item.report_name)) {
            lstIntermediateOutput.push(item);
          } else {
            lstOutput.push(item);
          }
        });
      }
      const dicIntermediateOutputByFilter =
        this.mappingDicIntermediateOutputByFilter(lstIntermediateOutput);
      this.setState(
        {
          lstOutput: lstOutput,
          lstIntermediateOutput: lstIntermediateOutput,
          dicIntermediateOutputByFilter: dicIntermediateOutputByFilter,
          loading: false,
        },
        () => {
          this.onChangeFilterIntermediateOutput();
        },
      );
    });
  };

  onReject = () => {
    this.setState({ showRejectAlert: true });
  };

  onConfirmReject = () => {
    Http.updateUploadInfo(
      Business.COMPONENT.NSFR,
      this.state.reportDate,
      this.state.reportName,
      Business.ENUMS.FILE_STATUS.REJECTED,
      this.state.reason,
    ).then((res) => {
      if (!res) {
        Business.showAlert({ title: "Error", content: "Unknow Error" });
      } else {
        if (res.Success) {
          Business.showAlert({ title: "Info", content: "Successfully" });
          this.handleHideShowBtn(Business.ENUMS.FILE_STATUS.REJECTED);
          this.setState({
            status: Business.convertFileStatus(
              Business.ENUMS.FILE_STATUS.REJECTED,
            ),
          });
        } else {
          switch (res.ErrorCode) {
            case ErrorCode.PermissionDenie:
              Business.showAlert({
                title: "Error",
                content: "You are not permission",
              });
            default:
              Business.showAlert({ title: "Error", content: "Unknow Error" });
          }
        }
      }
    });
    this.setState({ showRejectAlert: false });
  };

  onApproval = () => {
    Http.updateUploadInfo(
      Business.COMPONENT.NSFR,
      this.state.reportDate,
      this.state.reportName,
      Business.ENUMS.FILE_STATUS.APPROVED,
      null,
    ).then((res) => {
      if (!res) {
        Business.showAlert({ title: "Error", content: "Unknow Error" });
      } else {
        if (res.Success) {
          Business.showAlert({ title: "Info", content: "Successfully" });
          this.handleHideShowBtn(Business.ENUMS.FILE_STATUS.APPROVED);
          this.setState({
            status: Business.convertFileStatus(
              Business.ENUMS.FILE_STATUS.APPROVED,
            ),
          });
        } else {
          switch (res.ErrorCode) {
            case ErrorCode.PermissionDenie:
              Business.showAlert({
                title: "Error",
                content: "You are not permission",
              });
            default:
              Business.showAlert({ title: "Error", content: "Unknow Error" });
          }
        }
      }
    });
    this.setState({ showRejectAlert: false });
  };

  onCalculate = async () => {
    const isCalculating = await Business.hasBatchCalculating();
    if (isCalculating) {
      Business.showAlert({
        title: "Error",
        content: "The system is busy. Please try again in a few moments.",
      });
      return;
    }

    this.handleHideShowBtn(Business.ENUMS.FILE_STATUS.CALCULATING);
    this.setState({
      loading: true,
      errorCode: ErrorCode.PendingBatchProcessing,
      status: Business.convertFileStatus(
        Business.ENUMS.FILE_STATUS.CALCULATING,
      ),
    });
    Http.calculate(
      this.state.reportDate,
      this.state.reportName,
      this.state.singleConsol,
      this.state.scenario,
      true,
      Business.COMPONENT.NSFR,
    ).then((res) => {
      this.setState({ loading: false });
      if (res && res.ErrorCode === ErrorCode.PendingBatchProcessing) {
        this.onGetBatchResponse();
      } else {
        this.handleCalculateResponse(res);
      }
    });
  };

  onSelectInput = (inputName) => {
    if (inputName === "SELECT_ALL") {
      if (this.state.isSelectAllInput === true) {
        this.setState({ isSelectAllInput: false });
        this.state.lstInput.map((item) => {
          item.select = false;
        });
      } else {
        this.setState({ isSelectAllInput: true });
        this.state.lstInput.map((item) => {
          item.select = true;
        });
      }
    } else {
      this.state.lstInput.map((item) => {
        if (item.input === inputName) {
          if (item.select === true) {
            item.select = false;
          } else {
            item.select = true;
          }
        }
      });
    }
    this.forceUpdate();
  };

  onSelectOutput = (inputName) => {
    if (inputName === "SELECT_ALL") {
      if (this.state.isSelectAllOutput === true) {
        this.setState({ isSelectAllOutput: false });
        this.state.lstOutput.map((item) => {
          item.select = false;
        });
      } else {
        this.setState({ isSelectAllOutput: true });
        this.state.lstOutput.map((item) => {
          item.select = true;
        });
      }
    } else {
      this.state.lstOutput.map((item) => {
        if (item.report_name === inputName) {
          if (item.select === true) {
            item.select = false;
          } else {
            item.select = true;
          }
        }
      });
    }
    this.forceUpdate();
  };

  onSelectIntermediateOutput = (inputName) => {
    if (inputName === "SELECT_ALL") {
      if (this.state.isSelectAlIntermediateOutput === true) {
        this.setState({ isSelectAlIntermediateOutput: false });
        this.state.lstIntermediateOutput.map((item) => {
          item.select = false;
        });
      } else {
        this.setState({ isSelectAlIntermediateOutput: true });
        this.state.lstIntermediateOutput.map((item) => {
          item.select = true;
        });
      }
    } else {
      this.state.lstIntermediateOutput.map((item) => {
        if (item.report_name === inputName) {
          if (item.select === true) {
            item.select = false;
          } else {
            item.select = true;
          }
        }
      });
    }
    this.forceUpdate();
  };

  onDownloadInputFiles = async () => {
    const lstFileSelected = [];
    if (this.state.lstInput && this.state.lstInput.length > 0) {
      for (let i = 0; i < this.state.lstInput.length; i++) {
        const item = this.state.lstInput[i];
        if (item.select === true) {
          lstFileSelected.push(item.input);
        }
      }
    }

    if (lstFileSelected.length > 0) {
      this.setState({ loading: true });
      await handleBatchDownload(
        this.state.fileInfo,
        lstFileSelected,
        this.state.reportDate,
        this.state.reportName,
        "input_calculation",
        Business.COMPONENT.NSFR,
        (message) => {
          if (message) {
            this.setState({ downloadProgressMessage: message });
          } else {
            this.setState({ downloadProgressMessage: "", loading: false });
          }
        },
      );
    }
  };

  onDownloadOutputFiles = async () => {
    const lstFileSelected = [];
    if (this.state.lstOutput && this.state.lstOutput.length > 0) {
      for (let i = 0; i < this.state.lstOutput.length; i++) {
        const item = this.state.lstOutput[i];
        if (item.select === true) {
          lstFileSelected.push(item.report_name);
        }
      }
    }

    if (lstFileSelected.length > 0) {
      this.setState({ loading: true });
      await handleBatchDownload(
        this.state.fileInfo,
        lstFileSelected,
        this.state.reportDate,
        this.state.reportName,
        null,
        Business.COMPONENT.NSFR,
        (message) => {
          if (message) {
            this.setState({ downloadProgressMessage: message });
          } else {
            this.setState({ downloadProgressMessage: "", loading: false });
          }
        },
      );
    }
  };

  onDownloadIntermediateOutputFiles = async () => {
    const lstFileSelected = [];
    if (
      this.state.lstIntermediateOutput &&
      this.state.lstIntermediateOutput.length > 0
    ) {
      for (let i = 0; i < this.state.lstIntermediateOutput.length; i++) {
        const item = this.state.lstIntermediateOutput[i];
        if (item.select === true) {
          lstFileSelected.push(item.report_name);
        }
      }
    }

    if (lstFileSelected.length > 0) {
      this.setState({ loading: true });
      await handleBatchDownload(
        this.state.fileInfo,
        lstFileSelected,
        this.state.reportDate,
        this.state.reportName,
        null,
        Business.COMPONENT.NSFR,
        (message) => {
          if (message) {
            this.setState({ downloadProgressMessage: message });
          } else {
            this.setState({ downloadProgressMessage: "", loading: false });
          }
        },
      );
    }
  };

  onGetBatchResponse = () => {
    const intervalId = setInterval(() => {
      console.warn(`${this.state.reportName} | Request to get batch response`);
      Http.getBatchResult(this.state.reportDate, this.state.reportName).then(
        (res) => {
          this.handleGetBatchUploadingResponse(res);
        },
      );
    }, 3000);
    lstIntervalId.push(intervalId);
  };

  handleHideShowBtn(statusOfBatch) {
    if (statusOfBatch === Business.ENUMS.FILE_STATUS.REJECTED) {
      this.setState({
        isDisableRejectButton: true,
        isDisableApprovalButton: true,
        isDisableReasonInput: true,
        isDisableCalculateButton: true,
      });
    }
    if (
      statusOfBatch === Business.ENUMS.FILE_STATUS.APPROVED ||
      statusOfBatch === Business.ENUMS.FILE_STATUS.CALCULATION_STOPPED
    ) {
      this.setState({
        isDisableRejectButton: true,
        isDisableApprovalButton: true,
        isDisableReasonInput: true,
        isDisableCalculateButton: false,
      });
    }
    if (statusOfBatch === Business.ENUMS.FILE_STATUS.CALCULATING) {
      this.setState({
        isDisableRejectButton: true,
        isDisableApprovalButton: true,
        isDisableReasonInput: true,
        isDisableCalculateButton: true,
      });
    }
  }

  handleErrorCode(res) {
    this.handleHideShowBtn(Business.ENUMS.FILE_STATUS.CALCULATION_STOPPED);
    this.setState({
      status: Business.convertFileStatus(
        Business.ENUMS.FILE_STATUS.CALCULATION_STOPPED,
      ),
    });
    console.log(`Response: ${JSON.stringify(res || {})}`);
    if (res) {
      switch (res.ErrorCode) {
        case ErrorCode.PermissionDenie:
          Business.showAlert({
            title: "Error",
            content: "You are not permission",
          });
          break;
        case ErrorCode.Empty:
          Business.showAlert({ title: "Error", content: "File is empty" });
          break;
        case ErrorCode.Exist:
          Business.showAlert({
            title: "Error",
            content: "Name already exists in the system",
          });
          break;
        case ErrorCode.DataInvalid:
          Business.showAlert({
            title: "Error",
            content: res.Data || "System Error",
          });
          break;
        case ErrorCode.UnknowError:
          Business.showAlert({
            title: "Error",
            content: res.Data || "System Error",
          });
          break;
        default:
          Business.showAlert({
            title: "Error",
            content: res.Data || "Unknow Error",
          });
          break;
      }
    } else {
      Business.showAlert({ title: "Error", content: "Unknow Error" });
    }
  }

  handleCalculateResponse = (res) => {
    const errorCode = res ? res.ErrorCode : null;
    this.setState({ errorCode });
    if (res && res.Success) {
      const data = res.Data || {};
      this.setState({
        hasResult: true,
        icaapConsolReport: data,
      });
    } else {
      this.handleErrorCode(res);
    }
  };

  handleGetBatchUploadingResponse = (res) => {
    if (res) {
      if (res.ErrorCode === ErrorCode.PendingBatchProcessing) {
        console.warn(
          `${this.state.reportName} | Received state: PendingBatchProcessing`,
        );
      } else {
        console.warn(`${this.state.reportName} | Received state: Success`);
        const errorCode = res ? res.ErrorCode : null;
        this.setState({ errorCode });
        if (res && res.ErrorCode !== ErrorCode.PendingBatchProcessing) {
          clearGetBatchResponseInterval(this.state.reportName);
        }
        if (res && res.Success) {
          if (res.ErrorCode === ErrorCode.PendingBatchProcessing) {
            // console.warn('Received state: PendingBatchProcessing');
          } else if (res.ErrorCode === ErrorCode.BatchEmpty) {
            clearGetBatchResponseInterval(this.state.reportName);
            console.warn("Received state: BatchEmpty");
          } else {
            const data = res.Data || {};
            this.getReportList();
            this.setState({
              hasResult: true,
              icaapConsolReport: data,
              status: Business.convertFileStatus(
                Business.ENUMS.FILE_STATUS.CALCULATED,
              ),
            });
          }
        } else {
          this.handleErrorCode(res);
        }
      }
    }
  };

  renderPendingBatchProcessing = () => {
    return (
      <div>
        <div className="header">
          <h4
            style={{
              width: "100%",
              textAlign: "center",
              paddingBottom: "50px",
              paddingTop: "50px",
            }}
            className="title"
          >
            The system is calculating. Please wait...
          </h4>
        </div>
      </div>
    );
  };

  renderResult = () => {
    const report = this.state.icaapConsolReport || {};
    const nsfrResult = (report && report.NSFR_RESULT) || {};
    const toB = (v) =>
      v == null || v === undefined ? "-" : (v / 1e9).toFixed(4);
    const toPct = (v) =>
      v == null || v === undefined ? "-" : ((v || 0) * 100).toFixed(4) + "%";
    const summaryCards = [
      {
        title: "ASF",
        value: `${toB(nsfrResult.f_asf)} tỷ đ`,
        tone: "#e6f7ff",
      },
      {
        title: "RSF",
        value: `${toB(nsfrResult.f_rsf)} tỷ đ`,
        tone: "#fff7e6",
      },
      {
        title: "Tỷ lệ NSFR",
        value: toPct(nsfrResult.nsfr),
        tone: "#f6ffed",
      },
    ];

    return (
      <div style={{ animation: "nsfrFadeInUp .4s ease-out" }}>
        <style>
          {`@keyframes nsfrFadeInUp { from { opacity: 0; transform: translateY(12px);} to {opacity: 1; transform: translateY(0);} }`}
        </style>
        <div style={{ height: "20px" }} />
        <div
          style={{
            display: "grid",
            gridTemplateColumns: "repeat(auto-fit, minmax(220px, 1fr))",
            gap: 12,
            marginBottom: 16,
          }}
        >
          {summaryCards.map((card) => (
            <div
              key={card.title}
              style={{
                background: card.tone,
                borderRadius: 10,
                padding: 14,
                border: "1px solid #f0f0f0",
              }}
            >
              <div style={{ color: "#595959", fontSize: 13 }}>{card.title}</div>
              <div style={{ fontSize: 22, fontWeight: 700, marginTop: 4 }}>
                {card.value}
              </div>
            </div>
          ))}
        </div>

        <div
          style={{
            border: "1px solid #f0f0f0",
            borderRadius: 10,
            overflow: "hidden",
            boxShadow: "0 6px 20px rgba(0,0,0,.05)",
          }}
        >
          <Table striped bordered hover style={{ marginBottom: 0 }}>
            <thead>
              <tr>
                <th style={style.bolder}>STT</th>
                <th style={style.bolder}>Chi tiêu</th>
                <th style={style.bolder}>Đơn vị</th>
                <th style={style.bolder}>Giá trị gross (tỷ đồng)</th>
                <th style={style.bolder}>Giá trị sau hệ số (tỷ đồng)</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td
                  colSpan={5}
                  style={{ ...style.bolder, background: "#e8f0fe" }}
                >
                  I. NGUỒN VỐN ỔN ĐỊNH SẴN CÓ (ASF)
                </td>
              </tr>
              <tr>
                <td>1</td>
                <td>Vốn cấp 1 + Cấp 2 (ASF 100%)</td>
                <td>tỷ đ</td>
                <td>{toB(nsfrResult.n_tier12_capital)}</td>
                <td>{toB(nsfrResult.n_tier12_capital)}</td>
              </tr>
              <tr>
                <td>2</td>
                <td>Vốn khác (cổ phiếu quỹ, ưu đãi) (ASF 100%)</td>
                <td>tỷ đ</td>
                <td>{toB(nsfrResult.n_other_equity)}</td>
                <td>{toB(nsfrResult.n_other_equity)}</td>
              </tr>
              <tr>
                <td>3</td>
                <td>Nợ có KHCL ≥1 năm (ASF 100%)</td>
                <td>tỷ đ</td>
                <td>{toB(nsfrResult.n_lia_more_1y)}</td>
                <td>{toB(nsfrResult.n_lia_more_1y)}</td>
              </tr>
              <tr>
                <td>4</td>
                <td>Tiền gửi ổn định cá nhân &lt;1 năm (ASF 95%)</td>
                <td>tỷ đ</td>
                <td>{toB(nsfrResult.n_stable_less_1y)}</td>
                <td>{(+toB(nsfrResult.n_stable_less_1y) * 0.95).toFixed(4)}</td>
              </tr>
              <tr>
                <td>5</td>
                <td>Tiền gửi kém ổn định cá nhân &lt;1 năm (ASF 90%)</td>
                <td>tỷ đ</td>
                <td>{toB(nsfrResult.n_less_stable_less_1y)}</td>
                <td>
                  {(+toB(nsfrResult.n_less_stable_less_1y) * 0.9).toFixed(4)}
                </td>
              </tr>
              <tr>
                <td>6</td>
                <td>Vốn DN phi tài chính &lt;1 năm (ASF 50%)</td>
                <td>tỷ đ</td>
                <td>{toB(nsfrResult.n_non_fi_less_1y)}</td>
                <td>{(+toB(nsfrResult.n_non_fi_less_1y) * 0.5).toFixed(4)}</td>
              </tr>
              <tr>
                <td>7</td>
                <td>Tiền gửi vận hành TCTD (ASF 50%)</td>
                <td>tỷ đ</td>
                <td>{toB(nsfrResult.n_nsfr_operational_deposit)}</td>
                <td>
                  {(+toB(nsfrResult.n_nsfr_operational_deposit) * 0.5).toFixed(
                    4,
                  )}
                </td>
              </tr>
              <tr>
                <td>8</td>
                <td>Vốn Chính phủ/PSE &lt;1 năm (ASF 50%)</td>
                <td>tỷ đ</td>
                <td>{toB(nsfrResult.n_sovereign_less_1y)}</td>
                <td>
                  {(+toB(nsfrResult.n_sovereign_less_1y) * 0.5).toFixed(4)}
                </td>
              </tr>
              <tr>
                <td>9</td>
                <td>Vốn TCTD từ 6T-&lt;1 năm (ASF 50%)</td>
                <td>tỷ đ</td>
                <td>{toB(nsfrResult.n_fi_deposit_6m_1y)}</td>
                <td>
                  {(+toB(nsfrResult.n_fi_deposit_6m_1y) * 0.5).toFixed(4)}
                </td>
              </tr>
              <tr>
                <td>10</td>
                <td>Vốn TCTD &lt;6 tháng (ASF 0%)</td>
                <td>tỷ đ</td>
                <td>{toB(nsfrResult.n_fi_deposit_less_6m)}</td>
                <td>0.0000</td>
              </tr>
              <tr style={{ fontWeight: "bold" }}>
                <td />
                <td>Tổng ASF</td>
                <td>tỷ đ</td>
                <td></td>
                <td>{toB(nsfrResult.f_asf)}</td>
              </tr>

              <tr>
                <td
                  colSpan={5}
                  style={{ ...style.bolder, background: "#fff3cd" }}
                >
                  II. NGUỒN VỐN ỔN ĐỊNH YÊU CẦU (RSF)
                </td>
              </tr>
              <tr>
                <td>1</td>
                <td>Tiền mặt + NOSTRO tại TCTD (RSF 0%)</td>
                <td>tỷ đ</td>
                <td>{toB(nsfrResult.n_cashe_rsf)}</td>
                <td>0.0000</td>
              </tr>
              <tr>
                <td>2</td>
                <td>Dự trữ NHNN (RSF 0%)</td>
                <td>tỷ đ</td>
                <td>{toB(nsfrResult.n_sbvr_rsf)}</td>
                <td>0.0000</td>
              </tr>
              <tr>
                <td>3</td>
                <td>Phải thu NHNN &lt;6 tháng (RSF 0%)</td>
                <td>tỷ đ</td>
                <td>{toB(nsfrResult.n_sbv_rec_6m)}</td>
                <td>0.0000</td>
              </tr>
              <tr>
                <td>4</td>
                <td>Trái phiếu CP/NHNN ≥6 tháng (RSF 5%)</td>
                <td>tỷ đ</td>
                <td>{toB(nsfrResult.n_sovereign_rsf)}</td>
                <td>{(+toB(nsfrResult.n_sovereign_rsf) * 0.05).toFixed(4)}</td>
              </tr>
              <tr>
                <td>5</td>
                <td>Cho vay có đảm bảo HQLA C1 tới TCTD &lt;6T (RSF 10%)</td>
                <td>tỷ đ</td>
                <td>{toB(nsfrResult.n_secured_fi_type1_less_6m)}</td>
                <td>
                  {(+toB(nsfrResult.n_secured_fi_type1_less_6m) * 0.1).toFixed(
                    4,
                  )}
                </td>
              </tr>
              <tr>
                <td>6</td>
                <td>Cho vay TCTD khác &lt;6 tháng (RSF 15%)</td>
                <td>tỷ đ</td>
                <td>{toB(nsfrResult.n_fi_rec_less_6m)}</td>
                <td>{(+toB(nsfrResult.n_fi_rec_less_6m) * 0.15).toFixed(4)}</td>
              </tr>
              <tr>
                <td>7</td>
                <td>HQLA Cấp 2B (RSF 50%)</td>
                <td>tỷ đ</td>
                <td>{toB(nsfrResult.n_hqla_2b_rsf)}</td>
                <td>{(+toB(nsfrResult.n_hqla_2b_rsf) * 0.5).toFixed(4)}</td>
              </tr>
              <tr>
                <td>8</td>
                <td>HQLA cầm cố 6T-1năm (RSF 50%)</td>
                <td>tỷ đ</td>
                <td>{toB(nsfrResult.n_pledged_hqla_6m_1y)}</td>
                <td>
                  {(+toB(nsfrResult.n_pledged_hqla_6m_1y) * 0.5).toFixed(4)}
                </td>
              </tr>
              <tr>
                <td>9</td>
                <td>Cho vay TCTD 6T-1năm (RSF 50%)</td>
                <td>tỷ đ</td>
                <td>{toB(nsfrResult.n_fi_6m_1y)}</td>
                <td>{(+toB(nsfrResult.n_fi_6m_1y) * 0.5).toFixed(4)}</td>
              </tr>
              <tr>
                <td>10</td>
                <td>Tiền gửi vận hành tại TCTD (RSF 50%)</td>
                <td>tỷ đ</td>
                <td>{toB(nsfrResult.n_ope_rsf)}</td>
                <td>{(+toB(nsfrResult.n_ope_rsf) * 0.5).toFixed(4)}</td>
              </tr>
              <tr>
                <td>11</td>
                <td>TS không phải HQLA &lt;1 năm + lãi phải thu (RSF 50%)</td>
                <td>tỷ đ</td>
                <td>{toB(nsfrResult.n_non_hqla)}</td>
                <td>{(+toB(nsfrResult.n_non_hqla) * 0.5).toFixed(4)}</td>
              </tr>
              <tr>
                <td>12</td>
                <td>Cho vay KH ≥1 năm (RSF 85%)</td>
                <td>tỷ đ</td>
                <td>{toB(nsfrResult.n_rw_more_35)}</td>
                <td>{(+toB(nsfrResult.n_rw_more_35) * 0.85).toFixed(4)}</td>
              </tr>
              <tr>
                <td>13</td>
                <td>CK không HQLA ≥1 năm (RSF 85%)</td>
                <td>tỷ đ</td>
                <td>{toB(nsfrResult.n_listed_stock)}</td>
                <td>{(+toB(nsfrResult.n_listed_stock) * 0.85).toFixed(4)}</td>
              </tr>
              <tr>
                <td>14</td>
                <td>Vàng (RSF 85%)</td>
                <td>tỷ đ</td>
                <td>{toB(nsfrResult.n_commo_xau)}</td>
                <td>{(+toB(nsfrResult.n_commo_xau) * 0.85).toFixed(4)}</td>
              </tr>
              <tr>
                <td>15</td>
                <td>Phái sinh ròng (RSF 100%)</td>
                <td>tỷ đ</td>
                <td>{toB(nsfrResult.n_net_deri_rsf)}</td>
                <td>{toB(nsfrResult.n_net_deri_rsf)}</td>
              </tr>
              <tr>
                <td>16</td>
                <td>TS không xác định kỳ hạn + TS cố định (RSF 100%)</td>
                <td>tỷ đ</td>
                <td>{toB(nsfrResult.n_non_mature_asset)}</td>
                <td>{toB(nsfrResult.n_non_mature_asset)}</td>
              </tr>
              <tr>
                <td>17</td>
                <td>Tài sản khác (RSF 100%)</td>
                <td>tỷ đ</td>
                <td>{toB(nsfrResult.n_other_asset_rsf)}</td>
                <td>{toB(nsfrResult.n_other_asset_rsf)}</td>
              </tr>
              <tr>
                <td>18</td>
                <td>20% nợ phái sinh (RSF 100%)</td>
                <td>tỷ đ</td>
                <td>{toB(nsfrResult.n_deri_liabilities)}</td>
                <td>{toB(nsfrResult.n_deri_liabilities)}</td>
              </tr>
              <tr>
                <td>19</td>
                <td>Cam kết tín dụng không hủy ngang (RSF 5%)</td>
                <td>tỷ đ</td>
                <td>{toB(nsfrResult.n_commited_facilities)}</td>
                <td>
                  {(+toB(nsfrResult.n_commited_facilities) * 0.05).toFixed(4)}
                </td>
              </tr>
              <tr>
                <td>20</td>
                <td>Cam kết có thể hủy (RSF 5%)</td>
                <td>tỷ đ</td>
                <td>{toB(nsfrResult.n_not_commited_facilities)}</td>
                <td>
                  {(+toB(nsfrResult.n_not_commited_facilities) * 0.05).toFixed(
                    4,
                  )}
                </td>
              </tr>
              <tr style={{ fontWeight: "bold" }}>
                <td />
                <td>Tổng RSF</td>
                <td>tỷ đ</td>
                <td></td>
                <td>{toB(nsfrResult.f_rsf)}</td>
              </tr>

              <tr>
                <td
                  colSpan={5}
                  style={{ ...style.bolder, background: "#cce5ff" }}
                >
                  III. Kết quả NSFR
                </td>
              </tr>
              <tr style={{ fontWeight: "bold" }}>
                <td>1</td>
                <td>Tổng ASF</td>
                <td>tỷ đ</td>
                <td></td>
                <td>{toB(nsfrResult.f_asf)}</td>
              </tr>
              <tr style={{ fontWeight: "bold" }}>
                <td>2</td>
                <td>Tổng RSF</td>
                <td>tỷ đ</td>
                <td></td>
                <td>{toB(nsfrResult.f_rsf)}</td>
              </tr>
              <tr
                style={{
                  fontWeight: "bold",
                  fontSize: "1.1em",
                  color: "#0056b3",
                }}
              >
                <td>3</td>
                <td>Tỷ lệ vốn ổn định ròng (NSFR)</td>
                <td>%</td>
                <td></td>
                <td>{toPct(nsfrResult.nsfr)}</td>
              </tr>
            </tbody>
          </Table>
        </div>
      </div>
    );
  };

  handleSelectSingleConsolMethod = (eventKey, event) => {
    this.setState({ singleConsol: eventKey });
  };

  handleSelectFilterModuleMethod = (eventKey, event) => {
    const filterIntermediateOutput = this.state.filterIntermediateOutput;
    filterIntermediateOutput.module = eventKey;
    this.setState({ filterIntermediateOutput }, () => {
      this.onChangeFilterIntermediateOutput();
    });
  };

  handleSelectFilterPeriodsMethod = (eventKey, event) => {
    const filterIntermediateOutput = this.state.filterIntermediateOutput;
    filterIntermediateOutput.period = eventKey;
    this.setState({ filterIntermediateOutput }, () => {
      this.onChangeFilterIntermediateOutput();
    });
  };

  handleSelectFilterSecenariosMethod = (eventKey, event) => {
    const filterIntermediateOutput = this.state.filterIntermediateOutput;
    filterIntermediateOutput.scenario = eventKey;
    this.setState({ filterIntermediateOutput }, () => {
      this.onChangeFilterIntermediateOutput();
    });
  };

  onChangeFilterIntermediateOutput = () => {
    const filterIntermediateOutput = this.state.filterIntermediateOutput;
    const dicIntermediateOutputByFilter =
      this.state.dicIntermediateOutputByFilter;
    const { module, scenario, period } = filterIntermediateOutput;

    const lstIntermediateOutput = Object.values(
      dicIntermediateOutputByFilter[`${module}_${scenario}_${period}`] || {},
    );
    this.setState({ lstIntermediateOutput: lstIntermediateOutput });
  };

  handleSelectScenario = (eventKey, event) => {
    this.setState({ scenario: eventKey });
  };

  onShowUpdateNameAndReportDateModal = () => {
    this.setState({
      isShowUpdateNameAndReportDateModal: true,
    });
  };

  onCloseUpdateNameAndReportDateModal = () => {
    this.setState({
      isShowUpdateNameAndReportDateModal: false,
    });
  };

  onCloseUpdateNameAndReportDateModalAndGetNewData = (
    reportDate,
    reportName,
  ) => {
    const objSearch = {
      report_date: reportDate,
      file_name: reportName,
    };

    Http.getUploadManagement(Business.COMPONENT.NSFR, objSearch).then(
      (data) => {
        if (data && data.Success) {
          if (data.Data && data.Data.length === 1) {
            const fileInfo = data.Data[0];
            Business.showAlert({
              title: "Info",
              content: "Update successfully",
            });
            this.setState({
              fileInfo: fileInfo,
              reportDate: Business.convertToDate(fileInfo.report_date),
              reportName: fileInfo.file_name || "",
            });
          }
        }
      },
    );

    this.setState({
      isShowUpdateNameAndReportDateModal: false,
    });
  };

  renderUpdateNameAndReportDateModal = () => {
    return (
      <UpdateNameAndReportDateModalModal
        component={"ICAAP"}
        reportDate={this.state.reportDate}
        reportName={this.state.reportName}
        isShowUpdateNameAndReportDateModal={
          this.state.isShowUpdateNameAndReportDateModal
        }
        onCloseUpdateNameAndReportDateModal={
          this.onCloseUpdateNameAndReportDateModal
        }
        onCloseUpdateNameAndReportDateModalAndGetNewData={
          this.onCloseUpdateNameAndReportDateModalAndGetNewData
        }
      />
    );
  };

  renderBtnUpdateNameAndReportDate = () => {
    return (
      <i
        style={{ fontSize: 23, color: "red", cursor: "pointer !important" }}
        className="pe-7s-note"
        onClick={() => {
          this.setState({ isShowUpdateNameAndReportDateModal: true });
        }}
      ></i>
    );
  };

  renderInputFileManagement = () => {
    return (
      <div>
        <div style={{ fontWeight: 500, marginBottom: "10px" }}>
          <a
            rel="tooltip"
            aria-disabled="true"
            className="btn btn-info btn-simple btn-xs"
            data-original-title="View Profile"
            onClick={() => {
              this.onDownloadInputFiles();
            }}
          >
            <i
              style={{ fontSize: 23, color: "red" }}
              className="pe-7s-download"
            ></i>
          </a>
          <span>Download selected files</span>
        </div>
        <div
          style={{
            position: "relative",
            height: "300px",
            overflowY: "scroll",
            marginBottom: "30px",
          }}
        >
          <table className="table table-hover table-striped">
            <thead>
              <tr>
                <th>
                  <div className="form-check">
                    <input
                      class="form-check-input"
                      type="checkbox"
                      value=""
                      id="checkAllToDownload"
                      onChange={() => this.onSelectInput("SELECT_ALL")}
                      checked={this.state.isSelectAll === true}
                    />
                  </div>
                </th>
                <th>No.</th>
                <th>Input</th>
                <th>Uploader</th>
                <th>Upload Time</th>
              </tr>
            </thead>
            <tbody>
              {this.state.lstInput.map((item, index) => (
                <tr key={item.input}>
                  <td>
                    <div className="form-check">
                      <input
                        class="form-check-input"
                        type="checkbox"
                        value=""
                        id={`checkToDownload_${item.input}`}
                        onChange={() => this.onSelectInput(item.input)}
                        checked={item.select === true}
                      />
                    </div>
                  </td>
                  <td>{index + 1}</td>
                  <td style={{ color: "blue" }}>{item.input}</td>
                  <td>{item.upload_by}</td>
                  <td>{item.upload_time}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    );
  };

  renderOutputFileManagement = () => {
    return (
      <div>
        <div style={{ fontWeight: 500, marginBottom: "10px" }}>
          <a
            rel="tooltip"
            aria-disabled="true"
            className="btn btn-info btn-simple btn-xs"
            data-original-title="View Profile"
            onClick={() => {
              this.onDownloadOutputFiles();
            }}
          >
            <i
              style={{ fontSize: 23, color: "red" }}
              className="pe-7s-download"
            ></i>
          </a>
          <span>Download selected files</span>
        </div>
        <div
          style={{
            position: "relative",
            height: "300px",
            overflowY: "scroll",
            marginBottom: "30px",
          }}
        >
          <table className="table table-hover table-striped">
            <thead>
              <tr>
                <th>
                  <div className="form-check">
                    <input
                      class="form-check-input"
                      type="checkbox"
                      value=""
                      id="checkAllToDownload"
                      onChange={() => this.onSelectOutput("SELECT_ALL")}
                      checked={this.state.isSelectAll === true}
                    />
                  </div>
                </th>
                <th>No.</th>
                <th>Output</th>
                <th>CreatedTime</th>
              </tr>
            </thead>
            <tbody>
              {this.state.lstOutput.map((item, index) => (
                <tr key={item.report_name}>
                  <td>
                    <div className="form-check">
                      <input
                        class="form-check-input"
                        type="checkbox"
                        value=""
                        id={`checkToDownload_${item.report_name}`}
                        onChange={() => this.onSelectOutput(item.report_name)}
                        checked={item.select === true}
                      />
                    </div>
                  </td>
                  <td>{index + 1}</td>
                  <td style={{ color: "blue" }}>{item.report_name}</td>
                  <td>{item.created}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    );
  };

  renderIntermediateOutputFileManagement = () => {
    const lstFilterScenario = [];
    for (let e in dicFilterScenario) {
      lstFilterScenario.push(
        <MenuItem
          onSelect={(eventKey, event) => {
            this.handleSelectFilterSecenariosMethod(eventKey, event);
          }}
          eventKey={e}
        >
          {dicFilterScenario[e]}
        </MenuItem>,
      );
      lstFilterScenario.push(<MenuItem divider />);
    }
    return (
      <div>
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
          }}
        >
          <div style={{ fontWeight: 500, marginBottom: "10px" }}>
            <a
              rel="tooltip"
              aria-disabled="true"
              className="btn btn-info btn-simple btn-xs"
              data-original-title="View Profile"
              onClick={() => {
                this.onDownloadIntermediateOutputFiles();
              }}
            >
              <i
                style={{ fontSize: 23, color: "red" }}
                className="pe-7s-download"
              ></i>
            </a>
            <span>Download selected files</span>
          </div>
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
            }}
          >
            <div className="form-group">
              <div style={{ display: "inline", marginRight: 35 }}>
                <DropdownButton
                  title={
                    dicFilterModule[this.state.filterIntermediateOutput.module]
                  }
                  bsSize="small"
                  id={`dropdown-size-${1}`}
                >
                  <MenuItem
                    onSelect={(eventKey, event) => {
                      this.handleSelectFilterModuleMethod(eventKey, event);
                    }}
                    eventKey={`cr_cor`}
                  >
                    {dicFilterModule["cr_cor"]}
                  </MenuItem>
                  <MenuItem divider />
                  <MenuItem
                    onSelect={(eventKey, event) => {
                      this.handleSelectFilterModuleMethod(eventKey, event);
                    }}
                    eventKey={`mr_ccr`}
                  >
                    {dicFilterModule["mr_ccr"]}
                  </MenuItem>
                  <MenuItem divider />
                  <MenuItem
                    onSelect={(eventKey, event) => {
                      this.handleSelectFilterModuleMethod(eventKey, event);
                    }}
                    eventKey={`or`}
                  >
                    {dicFilterModule["or"]}
                  </MenuItem>
                  <MenuItem divider />
                  <MenuItem
                    onSelect={(eventKey, event) => {
                      this.handleSelectFilterModuleMethod(eventKey, event);
                    }}
                    eventKey={`irrbb_lr`}
                  >
                    {dicFilterModule["irrbb_lr"]}
                  </MenuItem>
                </DropdownButton>
              </div>
            </div>
            <div className="form-group">
              <div style={{ display: "inline", marginRight: 35 }}>
                <label
                  style={{ fontSize: 14, fontWeight: 300, marginRight: 10 }}
                >
                  Scenario:{" "}
                </label>
                <DropdownButton
                  title={
                    dicFilterScenario[
                      this.state.filterIntermediateOutput.scenario
                    ]
                  }
                  bsSize="small"
                  id={`dropdown-size-${1}`}
                >
                  {lstFilterScenario.map((e) => e)}
                </DropdownButton>
              </div>
            </div>
            <div className="form-group">
              <div style={{ display: "inline", marginRight: 10 }}>
                <label
                  style={{ fontSize: 14, fontWeight: 300, marginRight: 10 }}
                >
                  Period:{" "}
                </label>
                <DropdownButton
                  title={
                    dicFilterPeriods[this.state.filterIntermediateOutput.period]
                  }
                  bsSize="small"
                  id={`dropdown-size-${1}`}
                >
                  <MenuItem
                    onSelect={(eventKey, event) => {
                      this.handleSelectFilterPeriodsMethod(eventKey, event);
                    }}
                    eventKey={`all`}
                  >
                    {dicFilterPeriods["all"]}
                  </MenuItem>
                  <MenuItem divider />
                  <MenuItem
                    onSelect={(eventKey, event) => {
                      this.handleSelectFilterPeriodsMethod(eventKey, event);
                    }}
                    eventKey={`none`}
                  >
                    {dicFilterPeriods["none"]}
                  </MenuItem>
                  <MenuItem divider />
                  <MenuItem
                    onSelect={(eventKey, event) => {
                      this.handleSelectFilterPeriodsMethod(eventKey, event);
                    }}
                    eventKey={`t0`}
                  >
                    {dicFilterPeriods["t0"]}
                  </MenuItem>
                  <MenuItem divider />
                  <MenuItem
                    onSelect={(eventKey, event) => {
                      this.handleSelectFilterPeriodsMethod(eventKey, event);
                    }}
                    eventKey={`t1`}
                  >
                    {dicFilterPeriods["t1"]}
                  </MenuItem>
                  <MenuItem divider />
                  <MenuItem
                    onSelect={(eventKey, event) => {
                      this.handleSelectFilterPeriodsMethod(eventKey, event);
                    }}
                    eventKey={`t2`}
                  >
                    {dicFilterPeriods["t2"]}
                  </MenuItem>
                  <MenuItem divider />
                  <MenuItem
                    onSelect={(eventKey, event) => {
                      this.handleSelectFilterPeriodsMethod(eventKey, event);
                    }}
                    eventKey={`t3`}
                  >
                    {dicFilterPeriods["t3"]}
                  </MenuItem>
                </DropdownButton>
              </div>
            </div>
          </div>
        </div>
        <div
          style={{
            position: "relative",
            height: "300px",
            overflowY: "scroll",
            marginBottom: "30px",
          }}
        >
          <table className="table table-hover table-striped">
            <thead>
              <tr>
                <th>
                  <div className="form-check">
                    <input
                      class="form-check-input"
                      type="checkbox"
                      value=""
                      id="checkAllToDownload"
                      onChange={() =>
                        this.onSelectIntermediateOutput("SELECT_ALL")
                      }
                      checked={this.state.isSelectAll === true}
                    />
                  </div>
                </th>
                <th>No.</th>
                <th>Intermediate Output</th>
                <th>CreatedTime</th>
              </tr>
            </thead>
            <tbody>
              {this.state.lstIntermediateOutput.map((item, index) => (
                <tr key={item.report_name}>
                  <td>
                    <div className="form-check">
                      <input
                        class="form-check-input"
                        type="checkbox"
                        value=""
                        id={`checkToDownload_${item.report_name}`}
                        onChange={() =>
                          this.onSelectIntermediateOutput(item.report_name)
                        }
                        checked={item.select === true}
                      />
                    </div>
                  </td>
                  <td>{index + 1}</td>
                  <td style={{ color: "blue" }}>{item.report_name}</td>
                  <td>{item.created}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    );
  };

  render() {
    if (this.state.loading || this.state.downloadProgressMessage)
      return (
        <div style={{ height: Business.getHeightContent() }}>
          <Loading size="small" message={this.state.downloadProgressMessage} />
        </div>
      );
    const lstMenuScenario = [];
    for (let e in dicScenario) {
      lstMenuScenario.push(
        <MenuItem
          onSelect={(eventKey, event) => {
            this.handleSelectScenario(eventKey, event);
          }}
          eventKey={e}
        >
          {dicScenario[e]}
        </MenuItem>,
      );
      lstMenuScenario.push(<MenuItem divider />);
    }
    return (
      <div className="card">
        <div
          className="header"
          style={{
            display: "flex",
            justifyContent: "flex-start",
            alignItems: "center",
          }}
        >
          {this.state.fileInfo.status &&
            this.state.fileInfo.status !==
              Business.ENUMS.FILE_STATUS.CALCULATED &&
            this.state.fileInfo.status !==
              Business.ENUMS.FILE_STATUS.CALCULATING &&
            this.renderBtnUpdateNameAndReportDate()}
          <h4 className="title">{`${
            this.state.reportDate || ""
          } # ${Business.convertReportName(
            this.state.reportName || "",
            "ICAAP",
          )} # ${this.state.status || ""}`}</h4>
        </div>
        <div style={{ height: 15 }} />
        <div className="content table-responsive table-full-width">
          {(() => {
            const isResultScreen = this.state.hasResult;
            return (
              <div>
                {this.renderUpdateNameAndReportDateModal()}
                {isResultScreen ? (
                  this.renderResult()
                ) : (
                  <div>
                    {this.renderInputFileManagement()}

                    {this.state.lstOutput.length > 0 &&
                      this.renderOutputFileManagement()}

                    {console.log(
                      `${this.state.reportName} | file info status: ${this.state.fileInfo.status} | lst output length: ${this.state.lstOutput.length}`,
                    )}

                    <div>
                      <FormGroup controlId="formControlsTextarea">
                        <label htmlFor="exampleInputEmail1">
                          Reason for rejection:{" "}
                        </label>
                        <FormControl
                          style={{ height: "100px", resize: "none" }}
                          disabled={this.state.isDisableReasonInput}
                          componentClass="textarea"
                          value={this.state.reason}
                          placeholder="Type your reason here..."
                          onChange={(event) => {
                            this.setState({ reason: event.target.value });
                          }}
                        />
                      </FormGroup>
                      <div style={{ display: "inline" }}>
                        <button
                          type="button"
                          disabled={
                            this.state.progressValue > 0 ||
                            this.state.isDisableRejectButton
                          }
                          className="btn btn-primary"
                          style={{
                            backgroundColor: "rgb(255 0 0)",
                            borderColor: "rgb(255 255 255)",
                            borderRadius: "5px",
                            fontWeight: 600,
                            marginLeft: "auto",
                            float: "left",
                            color: "white",
                          }}
                          onClick={() => {
                            this.onReject();
                          }}
                        >
                          Reject
                        </button>
                        <div style={{ display: "flex", float: "right" }}>
                          <button
                            type="button"
                            disabled={
                              this.state.progressValue > 0 ||
                              this.state.isDisableApprovalButton ||
                              !Business.isHasRole([
                                Business.ROLE_DEFINE_MAP.ICAAP_APPROVAL_FILES,
                              ])
                            }
                            className="btn btn-primary"
                            style={{
                              backgroundColor: "#FFE600",
                              borderColor: "#7F7E82",
                              borderRadius: "5px 0px 0px 5px",
                              fontWeight: 600,
                            }}
                            onClick={() => {
                              this.onApproval();
                            }}
                          >
                            Approval
                          </button>
                          <button
                            type="button"
                            disabled={
                              this.state.progressValue > 0 ||
                              this.state.isDisableCalculateButton ||
                              !Business.isHasRole([
                                Business.ROLE_DEFINE_MAP.ICAAP_CALCULATE,
                              ])
                            }
                            className="btn btn-primary"
                            style={{
                              backgroundColor: "rgb(0 255 90)",
                              borderColor: "#7F7E82",
                              borderRadius: "0px 5px 5px 0px",
                              fontWeight: 600,
                            }}
                            onClick={() => {
                              this.onCalculate();
                            }}
                          >
                            Calculate
                          </button>
                        </div>
                      </div>
                    </div>
                    {this.state.errorCode ===
                      ErrorCode.PendingBatchProcessing &&
                      this.renderPendingBatchProcessing()}
                  </div>
                )}
              </div>
            );
          })()}
        </div>
        <Alert
          title="Are you sure?"
          text="You will not be able to undo!"
          show={this.state.showRejectAlert}
          showCancelButton
          onConfirm={() => {
            this.onConfirmReject();
          }}
          onCancel={() => {
            this.setState({ showRejectAlert: false });
          }}
        />
        <Alert
          title="Some files failed to download!"
          text={`Please check the following files: ${this.state.failedDownloadsList.join(
            ", ",
          )}`}
          show={this.state.showFileDownloadError}
          onConfirm={() => {
            this.setState({ showFileDownloadError: false });
          }}
        />
      </div>
    );
  }
}

const style = {
  bolder: {
    fontWeight: 600,
  },
};

let lstIntervalDownload = [];
function clearGetBatchDownloadInterval() {
  lstIntervalDownload.forEach((id) => {
    clearInterval(id);
    console.warn(`${id} | Received state: STOP`);
  });
}

async function handleBatchDownload(
  fileInfo,
  lstFileSelected,
  reportDate,
  reportName,
  type,
  component,
  cb,
) {
  try {
    const fileArr = (lstFileSelected || []).map((name) =>
      Http.makeDownloadFileInfo(name, reportDate, reportName, type, component),
    );
    const result = await Http.downloadAllFiles(fileArr, reportDate, reportName);
    cb && cb();

    if (result && result.is_error) {
      Business.showAlert({
        title: "Error",
        content: "Some files failed to download",
      });
    }
  } catch (error) {
    console.error(`handleBatchDownload - catch error: ${error.message}`);
    cb && cb();
    Business.showAlert({ title: "Error", content: "Download failed" });
  }
}

const lstIntervalId = [];
function clearGetBatchResponseInterval(reportName) {
  lstIntervalId.forEach((intervalId) => clearInterval(intervalId));
  console.warn(`${reportName} | Received state: STOP`);
}

function toPercentValue(value) {
  if (value == null || value === undefined) return "";
  return `${(value * 100).toLocaleString("en-GB")}%`;
}

function toAmountValue(value) {
  if (value == null || value === undefined) return "";
  return `${value.toLocaleString("en-GB")}`;
}

const DEFAULT_REPORT = {
  rwa_e: {
    bau_t0: 0,
    stress_t0: 0,
    bau_t1: 0,
    stress_t1: 0,
    bau_t2: 0,
    stress_t2: 0,
    bau_t3: 0,
    stress_t3: 0,
  },
  rwa_cr: {
    bau_t0: 0,
    stress_t0: 0,
    bau_t1: 0,
    stress_t1: 0,
    bau_t2: 0,
    stress_t2: 0,
    bau_t3: 0,
    stress_t3: 0,
  },
  rwa_or: {
    bau_t0: 0,
    stress_t0: 0,
    bau_t1: 0,
    stress_t1: 0,
    bau_t2: 0,
    stress_t2: 0,
    bau_t3: 0,
    stress_t3: 0,
  },
  rwa_mr: {
    bau_t0: 0,
    stress_t0: 0,
    bau_t1: 0,
    stress_t1: 0,
    bau_t2: 0,
    stress_t2: 0,
    bau_t3: 0,
    stress_t3: 0,
  },
  rwa_cor: {
    bau_t0: 0,
    stress_t0: 0,
    bau_t1: 0,
    stress_t1: 0,
    bau_t2: 0,
    stress_t2: 0,
    bau_t3: 0,
    stress_t3: 0,
  },
  rwa_irrbb: {
    bau_t0: 0,
    stress_t0: 0,
    bau_t1: 0,
    stress_t1: 0,
    bau_t2: 0,
    stress_t2: 0,
    bau_t3: 0,
    stress_t3: 0,
  },
  rwa_omr: {
    bau_t0: 0,
    stress_t0: 0,
    bau_t1: 0,
    stress_t1: 0,
    bau_t2: 0,
    stress_t2: 0,
    bau_t3: 0,
    stress_t3: 0,
  },
  //delta
  delta_rwa: {
    bau_t0: 0,
    stress_t0: 0,
    bau_t1: 0,
    stress_t1: 0,
    bau_t2: 0,
    stress_t2: 0,
    bau_t3: 0,
    stress_t3: 0,
  },
  delta_rwa_cr: {
    bau_t0: 0,
    stress_t0: 0,
    bau_t1: 0,
    stress_t1: 0,
    bau_t2: 0,
    stress_t2: 0,
    bau_t3: 0,
    stress_t3: 0,
  },
  delta_rwa_or: {
    bau_t0: 0,
    stress_t0: 0,
    bau_t1: 0,
    stress_t1: 0,
    bau_t2: 0,
    stress_t2: 0,
    bau_t3: 0,
    stress_t3: 0,
  },
  delta_rwa_mr: {
    bau_t0: 0,
    stress_t0: 0,
    bau_t1: 0,
    stress_t1: 0,
    bau_t2: 0,
    stress_t2: 0,
    bau_t3: 0,
    stress_t3: 0,
  },
  delta_rwa_cor: {
    bau_t0: 0,
    stress_t0: 0,
    bau_t1: 0,
    stress_t1: 0,
    bau_t2: 0,
    stress_t2: 0,
    bau_t3: 0,
    stress_t3: 0,
  },
  delta_rwa_irrbb: {
    bau_t0: 0,
    stress_t0: 0,
    bau_t1: 0,
    stress_t1: 0,
    bau_t2: 0,
    stress_t2: 0,
    bau_t3: 0,
    stress_t3: 0,
  },
  delta_rwa_omr: {
    bau_t0: 0,
    stress_t0: 0,
    bau_t1: 0,
    stress_t1: 0,
    bau_t2: 0,
    stress_t2: 0,
    bau_t3: 0,
    stress_t3: 0,
  },
  //Von tu co
  von_tu_co_ca: {
    bau_t0: 0,
    stress_t0: 0,
    bau_t1: 0,
    stress_t1: 0,
    bau_t2: 0,
    stress_t2: 0,
    bau_t3: 0,
    stress_t3: 0,
  },
  //Von yeu cau
  von_yeu_cau_cr: {
    bau_t0: 0,
    stress_t0: 0,
    bau_t1: 0,
    stress_t1: 0,
    bau_t2: 0,
    stress_t2: 0,
    bau_t3: 0,
    stress_t3: 0,
  },
  //Von kinh te
  von_kinh_te_ce: {
    bau_t0: 0,
    stress_t0: 0,
    bau_t1: 0,
    stress_t1: 0,
    bau_t2: 0,
    stress_t2: 0,
    bau_t3: 0,
    stress_t3: 0,
  },
  //Thue suat
  corp_tax: {
    bau_t0: 0,
    stress_t0: 0,
    bau_t1: 0,
    stress_t1: 0,
    bau_t2: 0,
    stress_t2: 0,
    bau_t3: 0,
    stress_t3: 0,
  },
  //Delta PNL
  delta_pnl: {
    bau_t0: 0,
    stress_t0: 0,
    bau_t1: 0,
    stress_t1: 0,
    bau_t2: 0,
    stress_t2: 0,
    bau_t3: 0,
    stress_t3: 0,
  },
  thay_doi_thu_nhap_lai: {
    bau_t0: 0,
    stress_t0: 0,
    bau_t1: 0,
    stress_t1: 0,
    bau_t2: 0,
    stress_t2: 0,
    bau_t3: 0,
    stress_t3: 0,
  },
  thay_doi_chi_phi_du_phong: {
    bau_t0: 0,
    stress_t0: 0,
    bau_t1: 0,
    stress_t1: 0,
    bau_t2: 0,
    stress_t2: 0,
    bau_t3: 0,
    stress_t3: 0,
  },
  thay_doi_thu_nhap_tu_rui_ro_thi_truong: {
    bau_t0: 0,
    stress_t0: 0,
    bau_t1: 0,
    stress_t1: 0,
    bau_t2: 0,
    stress_t2: 0,
    bau_t3: 0,
    stress_t3: 0,
  },
  ton_that_rui_ro_hoat_dong: {
    bau_t0: 0,
    stress_t0: 0,
    bau_t1: 0,
    stress_t1: 0,
    bau_t2: 0,
    stress_t2: 0,
    bau_t3: 0,
    stress_t3: 0,
  },
  chi_phi_thanh_khoan: {
    bau_t0: 0,
    stress_t0: 0,
    bau_t1: 0,
    stress_t1: 0,
    bau_t2: 0,
    stress_t2: 0,
    bau_t3: 0,
    stress_t3: 0,
  },
  ty_le_an_toan_von_car: {
    bau_t0: 0,
    stress_t0: 0,
    bau_t1: 0,
    stress_t1: 0,
    bau_t2: 0,
    stress_t2: 0,
    bau_t3: 0,
    stress_t3: 0,
  },
  ty_le_an_toan_von_cap_1_ct1: {
    bau_t0: 0,
    stress_t0: 0,
    bau_t1: 0,
    stress_t1: 0,
    bau_t2: 0,
    stress_t2: 0,
    bau_t3: 0,
    stress_t3: 0,
  },
  ty_le_an_toan_von_chu_so_huu_cap_1_cet1: {
    bau_t0: 0,
    stress_t0: 0,
    bau_t1: 0,
    stress_t1: 0,
    bau_t2: 0,
    stress_t2: 0,
    bau_t3: 0,
    stress_t3: 0,
  },
  ty_le_don_bay: {
    bau_t0: 0,
    stress_t0: 0,
    bau_t1: 0,
    stress_t1: 0,
    bau_t2: 0,
    stress_t2: 0,
    bau_t3: 0,
    stress_t3: 0,
  },
  roe: {
    bau_t0: 0,
    stress_t0: 0,
    bau_t1: 0,
    stress_t1: 0,
    bau_t2: 0,
    stress_t2: 0,
    bau_t3: 0,
    stress_t3: 0,
  },
  raroc: {
    bau_t0: 0,
    stress_t0: 0,
    bau_t1: 0,
    stress_t1: 0,
    bau_t2: 0,
    stress_t2: 0,
    bau_t3: 0,
    stress_t3: 0,
  },
};

export default FileInfo;



// WEBPACK FOOTER //
// src/pages/LiquidityRatio/NFSR/FileManagement/FileInfo.js